// extracted by mini-css-extract-plugin
var _1 = "section_figureWrapper";
var _2 = "section_section";
export { _1 as "figureWrapper", _2 as "section" }
